import React, { useEffect, useState } from 'react';
import Card from './Components/Card';

import useTours from '../../hooks/useTours';

import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { getPromoterService } from "../../services/getPromoterService";
import Logo from "./Components/Logo";
import Title from "./Components/Title";
import { HelmetProvider } from "react-helmet-async";
import MetaTags from "../../components/MetaTags";
import { Promoter } from '../../types/promoter';
import useExperiencesData from '../../hooks/useExperiencesData';
import { TripCard } from '../../types/trip';


const HomeContent = () => {
    const { tours, error, loading } = useTours();
    const { experiences, loading: experienceLoading } = useExperiencesData();
    const [promoter, setPromoter] = useState<Promoter | null>(null);
    const [allCards, setAllCards] = useState<TripCard[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);


    const navigate = useNavigate();


    useEffect(() => {
        const fetchPromoter = async () => {
            try {
                const _promoter = await getPromoterService();
                setPromoter(_promoter as any);
            } catch (e) {
                console.error(e, 'Error on load promoter');
            }
        };
        fetchPromoter();
    }, []);

    useEffect(() => {
        if (!loading && !experienceLoading && experiences && tours) {
            const mappedExperiences = experiences.map((experience): TripCard => ({
                id: experience.id,
                alias_url: experience.aliasUrl,
                promoter: experience.promoter,
                destination: '',
                thumbnailURL: experience.thumbnailURL,
                title: experience.title,
                description: experience.description,
                price: experience?.price,
                created_at: experience.created_at,
                isExperience: true,
            }));

            const orderedTripsAndExperiences = [...mappedExperiences, ...tours].sort((a, b) => {
                return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
            });

            setAllCards(orderedTripsAndExperiences);
            setIsLoading(false);
        }
    }, [loading, experienceLoading, experiences, tours]);


    const handleCardClick = (id: string, isExperience: boolean) => {
        if (!isExperience) {
            navigate(`/trip/${id}`);
        } else {
            navigate(`/experiences/${id}`);
        }
    };


    if (isLoading || loading || experienceLoading) {
        return <Loader />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const currentUrl = window.location.origin + window.location.pathname + window.location.search

    return (
        <HelmetProvider>
            <MetaTags
                name={`${promoter?.alias} | ${promoter?.fullname}`}
                image={promoter?.pictureURL}
                description={`${promoter?.alias} | ${promoter?.fullname}`}
                icon={promoter?.logoURL}
                title={`${promoter?.alias} | ${promoter?.fullname}`}
                url={currentUrl}
            />
            <div className="home__container">
                <div className='home__header'>
                    <Logo promoter={promoter} />
                    <Title promoter={promoter} />
                </div>
                <div className='app__cards'>
                    {allCards?.map(tour => (
                        <Card key={tour.id} card={tour} onClick={() => handleCardClick(tour.alias_url ? tour.alias_url : tour.id, tour?.isExperience ? tour?.isExperience : false)} />
                    ))}
                </div>
            </div>
        </HelmetProvider>
    );
}

export default HomeContent;
